import { combineReducers } from 'redux'
import notificationAlert from './NotificationState'
import updateTheme from './ThemeState'
import PatientListReducer from '../../pages/patient/PatientListSlice'
import UserRolesReducer from './UserRolesSlice'
import VisitDetailsReducer from '../../pages/opd/visits/visitDetails/VisitDetailsSlice'
import LabManagementReducer from './LabManagementSlice'
import BillingReducer from './BillingSlice'
import LabOrdersReducer from './LabOrdersSlice'
import IpdVisitDetailsReducer from '../../pages/ipd/visits/visitDetails/VisitDetailsSlice'
import NavigationReducer from './MasterNavigationSlice'
import TenantReducer from './TenantSlice'

export default combineReducers({
  notificationAlert,
  updateTheme,
  patientList: PatientListReducer,
  labManagement: LabManagementReducer,
  userRoles: UserRolesReducer,
  visitDetails: VisitDetailsReducer,
  billing: BillingReducer,
  labOrders: LabOrdersReducer,
  ipdVisitDetails: IpdVisitDetailsReducer,
  masterNavigation: NavigationReducer,
  tenant: TenantReducer,
})
